import {EMPTY_STORE, IS_SNOW_ACTIVE} from "../_types";

const initialState = {
    snow: undefined,
}

const snowReducer = (state = initialState , action) => {
    switch (action.type) {
        case IS_SNOW_ACTIVE:
            return {
                ...state,
                snow: action.payload
            }
        case EMPTY_STORE:
            return initialState;
        default :
            return {...state};
    }
}

export default snowReducer;